module.exports = __webpack_public_path__ + "static/6-0a0d578eb3acfec37a65f321148a8e76.jpg";